import React, { Component } from "react";
import styled from "styled-components";

import { CanvasEventType } from "../../../../common/constants";
import { PropertyPanelContainer } from "../../../EditorComponents/PropertyPanel";
import { PropertyPanelButton } from "../../../EditorComponents/PropertyPanelButton";
import { ShowDialog, ShowDialogAsync } from "../../../react/components/Dialogs/BaseDialog";
import { themeColors } from "../../../react/sharedStyles";
import { _ } from "../../../vendor";
import { PropertyPanelHeader } from "../../ElementEditor/PropertyPanelHeader";
import PresentationEditorController from "../../PresentationEditor/PresentationEditorController";
import { RegenerateImageDialog } from "../GenerateImage/RegenerateImageDialog";
import SlideAiController from "./SlideAiController";
import SlideAiDialog from "./SlideAiDialog";
import SlideAiIdeasList from "./SlideAiIdeasList";

class SlideAiIdeasPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentModel: _.cloneDeep(props.currentSlide.attributes),
            isGenerating: false,
            selectedModel: null,
            slideCategory: null,
            slideCategories: [],
        };

        this.hasBeenUnmounted = false;

        this.slideAiIdeasListRef = React.createRef();

        this.handleApplySlidePromiseChain = Promise.resolve();
    }

    componentDidMount() {
        const { currentSlide } = this.props;

        currentSlide.updateMetadata({ hasBeenViewed: true });

        PresentationEditorController.hideSelectionLayer();
    }

    componentDidUpdate(prevProps, prevState) {
        const { currentSlide } = this.props;

        if (prevProps.currentSlide !== currentSlide) {
            this.setState({
                currentModel: _.cloneDeep(currentSlide.attributes),
                isGenerating: false,
                selectedModelIndex: null,
                slideCategory: null
            });
        }
    }

    componentWillUnmount() {
        this.hasBeenUnmounted = true;

        PresentationEditorController.showSelectionLayer();
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.canvasController?.canvas?.isAnimating;
    }

    setStateAsync = async stateUpdate => {
        await new Promise(resolve => this.setState(stateUpdate, resolve));
    }

    handleRegenerateSlide = () => {
        const { currentSlide, currentCanvasController } = this.props;
        let { ideas } = ShowDialog(SlideAiDialog, { currentSlide, currentCanvasController });
        this.setState({ generatedSlides: ideas });
    }

    handleRegenerateImage = async () => {
        const { currentSlide, currentTheme } = this.props;

        const metadata = currentSlide.getMetadata();
        const slideImage = metadata.generatedModel?.slideImage;
        const imageSource = metadata.imageSource ?? "ai";

        let { imagePrompt, imageStyle } = await ShowDialogAsync(RegenerateImageDialog, {
            currentSlide,
            theme: currentTheme,
            prompt: slideImage?.prompt || "",
            imageSource: imageSource,
            imageStyle: slideImage?.imageStyle || "minimalist",
        });

        SlideAiController.regenerateSlideImage(imagePrompt, imageStyle);
    }

    handleApplySlide = async model => {
        const { currentSlide, currentCanvasController } = this.props;

        if (currentCanvasController.canvas.isAnimating) {
            currentCanvasController.canvas.stopAnimation();
        }

        this.handleApplySlidePromiseChain = this.handleApplySlidePromiseChain
            .then(async () => {
                currentSlide.update({
                    ...currentSlide.attributes,
                    animations: {},
                    states: model.states,
                    layout: model.layout,
                    template_id: model.template_id,
                    version: 10,
                    migrationVersion: 10.03,
                    metadata: {
                        ...model.metadata,
                        needsLayoutProcessing: true
                    }
                }, { removeMissingKeys: true, silent: true });
                currentSlide.trigger("forceSyncClones");

                await currentCanvasController.canvas.handleDataStateUpdate();

                await currentCanvasController.canvas.animate(() => { }, false);
            })
            .catch(() => { });
    }

    render() {
        let { currentSlide, generatedIdeas } = this.props;

        return (
            <PropertyPanelContainer fullHeight style={{ background: "#444" }}>
                <PropertyPanelHeader>
                    Slide AI
                </PropertyPanelHeader>
                <PropertyPanelButton icon="change_circle"
                    title="Generate Ideas..."
                    description="Switch any other smart slide and we'll try to preserve your existing content as best we can."
                    onClick={this.handleRegenerateSlide}
                    disabled={currentSlide !== SlideAiController.currentSlide}
                />
                {currentSlide === SlideAiController.currentSlide &&
                    <SlideAiIdeasList currentSlide={currentSlide}
                        generatedSlides={generatedIdeas}
                        slideWidth={290}
                        onSelect={this.handleApplySlide}
                    />
                }

            </PropertyPanelContainer>
        );
    }
}

export default SlideAiController.withState(SlideAiIdeasPanel);
